import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-empty-response',
  templateUrl: './empty-response-recieved.component.html',
  styleUrls: ['./empty-response-recieved.component.scss']
})
export class EmptyResponseRecievedComponent implements OnInit {

  @Input() message: string;
  @Input() enableRetry: boolean;
  @Input() retryMessage: string;
  @Output() onRetry = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    if (!this.retryMessage) {
      this.retryMessage = 'Retry';
    }
  }

  retry() {
    this.onRetry.emit();
  }

}
